export enum CompensationTypeRaw {
  Monthly = 'monthly',
  Hourly = 'hourly',
  Biweekly = 'biweekly',
  Yearly = 'yearly',
}
